import {
    CALENDAR_LOADING,
    CALENDAR_SET_MATCHES,
    CALENDAR_SET_DETAILS,
    CALENDAR_CLOSE_DETAILS
} from "./calendarActions";
import {GAME_SET} from "../Core/myResultsActions";

const init = {
    loading: false,
    stages: null,
    matches: null,
    details: null,
    show: true
};

export const calendarReducer = (state = init, action) => {
    switch (action.type) {
        case GAME_SET:
            return init;
        case CALENDAR_LOADING:
            return {
                ...state, loading: false, matches: action.payload, details: null
            };
        case CALENDAR_SET_MATCHES:
            return {
                ...state, loading: false, matches: action.payload
            };
        case CALENDAR_SET_DETAILS:
            return {...state, details: action.payload};
        case CALENDAR_CLOSE_DETAILS:
            return {...state, details: null};
        default:
            return state;
    }
};